import axios from 'axios';
import { Dispatch } from 'redux';
import SUMMARY_TYPES from './types';
import { ENV_CONFIG } from 'config/environment';
import { showToast } from 'components/Toast';
import API_ROUTES from 'services/apiRoutes';
import { getAccessToken } from 'services/storage';
import type { RootState } from 'store/create-store';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'X-Auth-Version': 'v2',
};

export const getTableSummary =
  (
    start_date: string,
    end_date: string,
    dimension: string,
    client_id: number | null,
    page?: string
  ) =>
  async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
    dispatch(SUMMARY_TYPES.summaryStart());
    const pageTag = page ? `&page=${page}` : '';
    const clientID = client_id ? `&client_id=${client_id}` : '';
    const activeRole = getState().admins?.activeRole ?? '';

    const url = `${ENV_CONFIG().API.BASE_URL}${API_ROUTES.GET_TABLE_SUMMARY(start_date, end_date, dimension, clientID, pageTag)}&active_role=${activeRole}`;
    try {
      const response = await axios.get(url, {
        headers: { ...headers, Authorization: `Bearer ${getAccessToken()}` },
      });
      dispatch(SUMMARY_TYPES.summarySuccess(response.data));
    } catch (error: any) {
      showToast(error.message, 'error', error?.response?.status);
      dispatch(SUMMARY_TYPES.summaryError(error.message));
    }
  };
